import React from 'react';
import swal from 'sweetalert';

import ImageDropZone from '../../components/GlobalImageDropZone';

import I18n from '../../locales/i18n';

const ControlLogo = ({
	image,
	folder,
	defaultImage = '',
	onRequestLoading,
	name,
	dbName,
	setParam,
	className = '',
	onValidation,
}) => {
	const [photo, setPhoto] = React.useState(image);
	const [timestamp, setTimeStamp] = React.useState(new Date().getTime());
	const [_defaultImage, setDefaultImage] = React.useState(defaultImage);

	const [isLoading, setLoadingStatus] = React.useState(false);

	React.useEffect(() => {
		if (defaultImage === '') {
			setDefaultImage(image);
		}
	}, [defaultImage, image]);

	const onChangeImage = ({ name, ext, path }) => {
		setParam({ [dbName]: true })
			.then(() => {
				setPhoto(path);
				setTimeStamp(new Date().getTime());
			})
			.catch((error) => {
				console.error(error);
				swal('Error', I18n('MY_BRAND', 'IMAGE_SAVED_ERROR'), 'error');
			});
	};

	const onDeleteImage = (name) => {
		setLoadingStatus(true);

		setParam({ [dbName]: false })
			.then(() => {
				setPhoto(_defaultImage);
				setTimeStamp(new Date().getTime());
				setLoadingStatus(false);
			})
			.catch((error) => {
				console.error(error);
				swal('Error', I18n('MY_BRAND', 'IMAGE_SAVED_ERROR'), 'error');
				setLoadingStatus(false);
			});
	};

	return (
		<ImageDropZone
			className={'drop col-md-12 ' + className}
			onChangeImage={onChangeImage}
			onDeleteImage={onDeleteImage}
			onRequestLoading={onRequestLoading}
			folder={folder}
			isLoading={isLoading}
			onValidation={onValidation}
			name={name}
			photoURL={photo + `?t=${timestamp}`}
		/>
	);
};

export default ControlLogo;
